import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2071b5',
        secondary: '#ffda00',
        accent: '#124168',
        error: '#b71c1c',
        anchor: '#165182',
        highlight: '#DCEDF9',
        textGray: '#3a3a3a'
      }
    }
  },
  breakpoint: {
    mobileBreakpoint: 'xs'
  }
})
